import React, { useState } from 'react';
import { FaCopy, FaUniversity, FaWhatsapp } from 'react-icons/fa';
import {
  MAX_PAGES,
  PAYMENT_ACCOUNT,
  buildPagePricingWhatsAppUrl,
  formatSar,
  pagePricingTotal,
  parsePageCount,
  pricePerPage,
} from '../../config/pagePricingServices';

const copyText = async (value) => {
  try {
    await navigator.clipboard.writeText(value);
    window.alert('تم النسخ بنجاح');
  } catch (err) {
    window.alert('تعذر النسخ');
  }
};

const PagePricingFlow = ({ service }) => {
  const [step, setStep] = useState(1);
  const [pagesInput, setPagesInput] = useState('1');
  const rate = pricePerPage(service);
  const parsed = parsePageCount(pagesInput);
  const total = rate != null && parsed.ok ? pagePricingTotal(service, parsed.value) : null;
  const serviceName = service?.name || 'الخدمة';

  const setPages = (next) => {
    const clamped = Math.min(MAX_PAGES, Math.max(1, next));
    setPagesInput(String(clamped));
  };

  if (!service?.id) {
    return (
      <div className="booking-step">
        <h2 className="step-title">الخدمة غير متاحة</h2>
        <p className="page-pricing-error">تعذر تحديد الخدمة. عودي لصفحة الخدمات واختاري الخدمة من جديد.</p>
      </div>
    );
  }

  if (rate == null) {
    return (
      <div className="booking-step">
        <h2 className="step-title">{serviceName}</h2>
        <p className="page-pricing-error">سعر الصفحة غير متوفر لهذه الخدمة. لا يمكن إتمام الطلب الآن.</p>
      </div>
    );
  }

  return (
    <div className="booking-step page-pricing">
      <p className="page-pricing-progress">الخطوة {step} من 2</p>
      {step === 2 && (
        <button type="button" className="btn-back" onClick={() => setStep(1)}>
          → عودة لعدد الصفحات
        </button>
      )}
      <h2 className="step-title">{serviceName}</h2>

      {step === 1 && (
        <>
          <label className="page-pricing-label" htmlFor="page-count">
            عدد الصفحات
          </label>
          <div className="page-pricing-counter">
            <button
              type="button"
              aria-label="إنقاص صفحة"
              onClick={() => setPages((parsed.ok ? parsed.value : 1) - 1)}
              disabled={parsed.ok && parsed.value <= 1}
            >
              −
            </button>
            <input
              id="page-count"
              inputMode="numeric"
              value={pagesInput}
              onChange={(event) => setPagesInput(event.target.value)}
              aria-invalid={!parsed.ok}
            />
            <button
              type="button"
              aria-label="زيادة صفحة"
              onClick={() => setPages((parsed.ok ? parsed.value : 1) + 1)}
              disabled={parsed.ok && parsed.value >= MAX_PAGES}
            >
              +
            </button>
          </div>
          {!parsed.ok && <p className="page-pricing-error">{parsed.error}</p>}
          {parsed.ok && total != null && (
            <p className="page-pricing-formula">
              {parsed.value} صفحة × {rate} ريال = {formatSar(total)}
            </p>
          )}
          <button
            type="button"
            className="btn-primary-action"
            disabled={!parsed.ok || total == null}
            onClick={() => setStep(2)}
          >
            متابعة الدفع
          </button>
        </>
      )}

      {step === 2 && parsed.ok && total != null && (
        <div className="payment-card payment-card-full">
          <p className="page-pricing-formula">
            {parsed.value} صفحة × {rate} ريال = {formatSar(total)}
          </p>
          <h3>بيانات التحويل البنكي</h3>
          <div className="bank-text-info">
            <div className="bank-header">
              <FaUniversity size={24} color="#402336" />
              <span className="bank-name">{PAYMENT_ACCOUNT.bankName}</span>
            </div>
            <div className="info-row">
              <span className="label">اسم المستفيد:</span>
              <span className="value">{PAYMENT_ACCOUNT.accountHolder}</span>
            </div>
            <AccountRow label="رقم الحساب:" value={PAYMENT_ACCOUNT.accountNumber} />
            <AccountRow label="رقم الآيبان:" value={PAYMENT_ACCOUNT.iban} />
          </div>
          <a
            className="btn-whatsapp"
            href={buildPagePricingWhatsAppUrl({
              serviceName,
              pages: parsed.value,
              total,
            })}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp /> إرسال الطلب عبر الواتساب
          </a>
        </div>
      )}
    </div>
  );
};

const AccountRow = ({ label, value }) => (
  <div className="info-row">
    <span className="label">{label}</span>
    <div className="copy-wrapper">
      <span className="value mono">{value}</span>
      <button type="button" className="btn-copy" aria-label={`نسخ ${label}`} onClick={() => copyText(value)}>
        <FaCopy />
      </button>
    </div>
  </div>
);

export default PagePricingFlow;
